<template>
  <Content :is-accountant="isAccountant">
    <div class="container">
      <div
        v-if="isLoading"
        class="md-card-graph-total loading-total">
        <Spinner
          name="line-scale-pulse-out-rapid"
          color="#448aff"
          no-fade-in />
      </div>
      <div
        v-else
        class="md-layout">
        <md-list
          class="md-double-line md-layout-item md-card-dash"
          style="flex: 0 0 100%;"
        >
          <md-list-item>
            <div class="md-list-item-text">
              <span
                class="title-card-dash"
                style="white-space: normal">
                Última atualização dos valores em: {{ lastDashboardUpdate }}
              </span>
            </div>
            <md-button
              class="md-raised md-primary"
              @click="updateDashboardCache"
            >
              Atualizar
            </md-button>
          </md-list-item>
        </md-list>

        <md-list
          v-show="getDocTotalByModel.nfe.length > 0"
          class="md-double-line md-layout-item md-size-30 md-card-dash"
        >
          <div class="title-card">NFe</div>
          <div v-for="total in getDocTotalByModel.nfe">
            <md-list-item v-if="total.type != null">
              <md-avatar v-if="total.type == PURCHASE">
                <md-icon class="icon-purchase">shopping_cart</md-icon
                ><md-tooltip md-direction="left">Entradas</md-tooltip>
              </md-avatar>
              <md-avatar v-if="total.type == SALE">
                <md-icon class="icon-sale">attach_money</md-icon
                ><md-tooltip md-direction="left">Saídas</md-tooltip>
              </md-avatar>

              <div
                v-if="total.type == PURCHASE"
                class="md-list-item-text"
                @click="access(total.model)"
              >
                <span
                  class="title-card-dash"
                >Entradas: {{ total.totaldoc }}</span
                >
                <span
                  class="title-card-dash"
                >R$: {{ total.totalvalue | currency }}</span
                >
                <md-tooltip
                  v-if="!isAccountant"
                  md-direction="bottom"
                >Acessar
                </md-tooltip>
                <md-divider class="md-inset" />
              </div>

              <div
                v-if="total.type == SALE"
                class="md-list-item-text"
                @click="access(total.model)"
              >
                <span
                  class="title-card-dash"
                >Saídas: {{ total.totaldoc }}</span
                >
                <span
                  class="title-count"
                >R$: {{ total.totalvalue | currency }}</span
                >
                <md-tooltip
                  v-if="!isAccountant"
                  md-direction="bottom"
                >Acessar
                </md-tooltip>
                <md-divider class="md-inset" />
              </div>
            </md-list-item>
          </div>
        </md-list>

        <md-list
          v-show="getDocTotalByModel.nfce.length > 0"
          class="md-double-line md-layout-item md-size-30 md-card-dash-nfce-sat"
        >
          <div class="title-card">NFCe</div>
          <div v-for="total in getDocTotalByModel.nfce">
            <md-list-item v-if="total.type == SALE">
              <md-avatar>
                <md-icon class="icon-sale">attach_money</md-icon>
              </md-avatar>
              <div
                class="md-list-item-text"
                @click="access(total.model)">
                <span
                  class="title-card-dash"
                >Saídas: {{ total.totaldoc }}</span
                >
                <span
                  class="title-count"
                >R$: {{ total.totalvalue | currency }}</span
                >
                <md-tooltip
                  v-if="!isAccountant"
                  md-direction="bottom"
                >Acessar
                </md-tooltip>
                <md-divider class="md-inset" />
              </div>
            </md-list-item>
          </div>
        </md-list>

        <md-list
          v-show="getDocTotalByModel.sat.length > 0"
          class="md-double-line md-layout-item md-size-30 md-card-dash-nfce-sat"
        >
          <div class="title-card">SAT</div>
          <div v-for="total in getDocTotalByModel.sat">
            <md-list-item>
              <md-avatar>
                <md-icon class="icon-sale">attach_money</md-icon>
              </md-avatar>
              <div
                class="md-list-item-text"
                @click="access(total.model)">
                <span
                  class="title-card-dash"
                >Saídas: {{ total.totaldoc }}</span
                >
                <span
                  class="title-count"
                >R$: {{ total.totalvalue | currency }}</span
                >
                <md-tooltip
                  v-if="!isAccountant"
                  md-direction="bottom"
                >Acessar
                </md-tooltip>
                <md-divider class="md-inset" />
              </div>
            </md-list-item>
          </div>
        </md-list>
      </div>

      <div class="md-layout md-size-20">
        <div class="field-date">
          <date-picker
            v-model="dateEmissionFrom"
            lang="pt-br"
            format="DD/MM/YYYY"
            width="150"
            placeholder="De"
          />
          <date-picker
            v-model="dateEmissionTo"
            lang="pt-br"
            format="DD/MM/YYYY"
            width="150"
            placeholder="Até"
          />
        </div>
        <div class="field-model">
          <md-field>
            <md-select
              id="modelCharts"
              v-model="modelCharts"
              name="modelCharts"
            >
              <md-option value="55">NF-e</md-option>
              <md-option value="65">NFC-e</md-option>
              <md-option value="59">SAT</md-option>
            </md-select>
            <md-tooltip
              md-direction="bottom"
            >Escolha o tipo de Documento</md-tooltip
            >
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <div
            v-if="isLoading"
            class="loading-total-graph">
            <Spinner
              name="line-scale-pulse-out-rapid"
              color="#448aff"
              no-fade-in
            />
          </div>
          <div
            v-else
            class="md-card-charts">
            <div class="title-card-charts">
              Totais emitidas por período: {{ qtdTotalByModel }}
            </div>
            <BarChart :chart-data="dataCollection" />
          </div>
        </div>

        <div class="md-layout-item">
          <div
            v-if="isLoading"
            class="loading-total-graph">
            <Spinner
              name="line-scale-pulse-out-rapid"
              color="#448aff"
              no-fade-in
            />
          </div>
          <div
            v-else
            class="md-card-charts">
            <div class="title-card-charts">
              Totais por período R$ {{ valorTotalByModel | currency }}
            </div>
            <LineChart
              :chart-data="dataCollectionMonetary"
              :styles="myStyles"
            />
          </div>
        </div>

        <div class="md-layout-item">
          <div
            v-if="isLoading"
            class="loading-total-graph">
            <Spinner
              name="line-scale-pulse-out-rapid"
              color="#448aff"
              no-fade-in
            />
          </div>
          <div v-else>
            <div class="title-card-charts">Status dos documentos:</div>
            <Doughnut :chart-data="dataCollectionStatus" />
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import Spinner from 'vue-spinkit';
import Content from '../public/Content.vue';
import BarChart from './BarDash';
import LineChart from './LineDash';
import Doughnut from './DoughnutDash';
import { NFE, NFCE, SAT } from '../../public/api/docConst';
import { docStatus } from '../../public/api/docStatus';
import { http, getTokenInURL } from '../../public/api/backend';

export default {
  name: 'Dashboard',
  components: {
    Content,
    BarChart,
    LineChart,
    DatePicker,
    Spinner,
    Doughnut,
  },
  data() {
    return {
      client: [],
      loadingTotal: true,
      loadingCharts: true,
      totalByModel: [],
      valorTotalByModel: 0,
      qtdTotalByModel: 0,
      dataCollection: null,
      dataCollectionMonetary: null,
      dataCollectionStatus: null,
      modelCharts: 55,
      fromEmission: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      toEmission: moment().format('YYYY-MM-DD'),
      lastDashboardUpdate: null,
      dateEmissionFrom: null,
      dateEmissionTo: null,
      height: 460,
      selected: [],
      isAccountant: false
    };
  },
  computed: {
    myStyles() {
      return {
        height: `${this.height}px`,
      };
    },
    identificationClient() {
      return this.$store.getters.identificationClient;
    },
    getDocTotalByModel() {
      return this.$store.getters.getDocTotalByModel;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    SALE() {
      return docStatus.SALE;
    },
    PURCHASE() {
      return docStatus.PURCHASE;
    },
    getSped() {
      return this.$store.getters.getSped.data;
    },
  },
  async mounted() {
    const getTotalsMethod = 'getTotalsDashboard';

    if (this.checkIsAccountant(this.$route.fullPath)) {
      this.isAccountant = true;
      await this.getTotals(getTotalsMethod);
      return;
    }

    const token = getTokenInURL(this.$route.fullPath);
    if (token) {
      localStorage.setItem('access_token', token);
      await this.getClient();
      this.$router.push({ path: '/dashboard' });
      return;
    }

    await this.getClient();
    await this.getTotals(getTotalsMethod);
  },
  methods: {
    checkIsAccountant(url) {
      if (!url.includes('/accountant')) return false;
      return true;
    },

    async getClient() {
      http.post('application.get-client')
        .then(response => {
          this.client = response.data
          this.$store.commit('SET_CLIENT_IDENTIFICATION', response.data.identification)
        })

      const getTotalsMethod = 'getTotalsDashboard';
      await this.getTotals(getTotalsMethod);
    },

    access(model) {
      if (this.isAccountant) return;

      this.$router.push({ path: `/notas/${model}` })
    },

    async updateDashboardCache() {
      const getTotalsMethod = 'updateTotalsDashboard';
      await this.getTotals(getTotalsMethod);
    },

    async getTotals(method) {
      const fromDate = this.dateEmissionFrom
        ? moment(this.dateEmissionFrom).format('YYYY-MM-DD')
        : this.fromEmission;
      const toDate = this.dateEmissionTo
        ? moment(this.dateEmissionTo).format('YYYY-MM-DD')
        : this.toEmission;
      const data = {
        fromEmission: fromDate,
        toEmission: toDate,
        model: this.modelCharts,
      };

      await this.$store.commit('SET_DOCS', data);
      await this.$store.commit('SET_LOADING_STATUS', true);
      await this.$store.dispatch(method, {
        identification: this.identificationClient
      });

      if (!this.$store.getters.getIsCached) return;

      this.lastDashboardUpdate = this.$store.getters.getDocUpdatedAt;
      const params = this.$store.getters.getDocParams;
      this.dateEmissionFrom = moment(params.fromEmission).format('YYYY/MM/DD');
      this.dateEmissionTo = moment(params.toEmission).format('YYYY/MM/DD');
      this.modelCharts = params.model;

      await this.getFieldsChartBar();
      await this.getTotalsMonetary();
      await this.getTotalsStatus();
    },

    getFieldsChartBar() {
      let labelChart = '';
      let backgroundChart = '';
      switch (this.modelCharts) {
        case NFE.toString():
          labelChart = 'NF-e Emitidas';
          backgroundChart = '#9dcf6b';
          break;
        case NFCE.toString():
          labelChart = 'NFC-e Emitidas';
          backgroundChart = '#8e24aa';
          break;
        case SAT.toString():
          labelChart = 'SAT Emitidos';
          backgroundChart = '#ff5722';
          break;
        default:
          labelChart = 'NF-e Emitidas';
          backgroundChart = '#9dcf6b';
      }

      const totalColletion = this.$store.getters.getDocTotalByDetails.map(
        (total) => total.totaldoc
      );

      const labelsColletion = this.$store.getters.getDocTotalByDetails.map(
        (emission) => moment(emission.emissiondate).format('DD/MM/YY')
      );

      let qtd = 0;

      for (let i = 0; i < totalColletion.length; i++) {
        if (totalColletion[i] != null) {
          qtd += parseFloat(totalColletion[i]);
        }
      }

      this.qtdTotalByModel = parseFloat(qtd).toFixed(0);

      this.dataCollection = {
        labels: labelsColletion,
        datasets: [
          {
            label: labelChart,
            backgroundColor: backgroundChart,
            data: totalColletion,
          },
        ],
      };
    },

    getTotalsMonetary() {
      let labelChart = '';
      let backgroundChart = '';
      switch (this.modelCharts) {
        case NFE.toString():
          labelChart = 'NF-e Valor';
          backgroundChart = '#ccff90';
          break;
        case NFCE.toString():
          labelChart = 'NFC-e Valor';
          backgroundChart = '#ce93d8';
          break;
        case SAT.toString():
          labelChart = 'SAT Valor';
          backgroundChart = '#ffab91';
          break;
        default:
          labelChart = 'NF-e Valor';
          backgroundChart = '#ccff90';
      }

      const totalColletion = this.$store.getters.getDocTotalByDetails.map(
        (total) => total.totalvalue
      );

      let total = 0;

      for (let i = 0; i < totalColletion.length; i++) {
        if (totalColletion[i] != null) {
          total += parseFloat(totalColletion[i]);
        }
      }

      this.valorTotalByModel = parseFloat(total).toFixed(2);

      const labelsColletion = this.$store.getters.getDocTotalByDetails.map(
        (emission) => moment(emission.emissiondate).format('DD/MM/YY')
      );

      this.dataCollectionMonetary = {
        labels: labelsColletion,
        datasets: [
          {
            label: labelChart,
            backgroundColor: backgroundChart,
            data: totalColletion,
          },
        ],
      };
      this.loadingCharts = false;
    },

    getTotalsStatus() {
      this.dataCollectionStatus = {
        labels: ['Autorizadas', 'Canceladas', 'Inutilizadas'],
        datasets: [
          {
            backgroundColor: ['#ccff90', '#c0392b', '#7e7e7e'],
            data: [
              this.$store.getters.getDocTotalByStatus.totalAuthorized.total,
              this.$store.getters.getDocTotalByStatus.totalCanceled.total,
              this.$store.getters.getDocTotalByStatus.totalUnitilized.total,
            ],
          },
        ],
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/client/home/Dashboard.vue